// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__oRySJ","bigColWidth":"Table_bigColWidth__3FWtB","biggerColWidth":"Table_biggerColWidth__eGwxH","row":"Table_row__1llMv","col":"Table_col__3xkq8"};